import { useState } from 'react';
import PrescriptionModal from './PrescriptionModal';

export default function Prescription({
  calendar,
  user,
  demoMode,
  trads,
  lang,
  langUrl,
  onEventSave,
  onEventDelete,
}) {
  const [selectedEvent, setSelectedEvent] = useState(null);

  const tIndex = trads?.index || {};

  const prescriptionEvents = (calendar?.events || []).filter(
    (e) => e.everyDays != null && e.everyDays >= 1
  );

  const handleNewPrescription = () => {
    setSelectedEvent({
      id: null,
      type: 'sequence',
      name: '',
      content: '',
      everyDays: 2,
      days: [],
      daysInMonth: [],
      times: [600], // 10:00 AM default
      groupIds: [],
      eventContacts: [],
    });
  };

  return (
    <div className="mb-8">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900">
          <span>
            {tIndex.prescriptionTitle || 'Reminder sequences (every n days)'}
          </span>
        </h2>
        <p className="mt-1 text-sm text-gray-500">
          {tIndex.prescriptionDescription ||
            'Cadence for medical or high-frequency sends.'}
        </p>
      </div>

      <div className="space-y-3 mb-4">
        {prescriptionEvents.length === 0 ? (
          <div className="text-sm text-gray-500">
            {tIndex.noPrescriptions || 'No reminder sequences yet.'}
          </div>
        ) : (
          prescriptionEvents.map((evt) => (
            <div
              key={evt.id}
              onClick={() => setSelectedEvent(evt)}
              className="p-4 border border-gray-200 rounded-lg bg-white hover:bg-indigo-50/50 hover:border-indigo-100 cursor-pointer transition-colors"
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium text-gray-900">
                    {evt.name || tIndex.eventPlaceholder || 'Event'}
                  </div>
                  <div className="text-sm text-gray-500 mt-1">
                    {evt.everyDays === 1
                      ? `${tIndex.every || 'Every'} ${tIndex.dayLabelSingular || 'day'}`
                      : `${tIndex.every || 'Every'} ${evt.everyDays} ${tIndex.daysLabel || 'days'}`}{' '}
                    ·{' '}
                    {evt.times
                      ?.map((t) => {
                        const h = Math.floor(t / 60);
                        const m = t % 60;
                        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
                      })
                      .join(', ')}
                  </div>
                </div>
                <div className="text-gray-400 text-sm">→</div>
              </div>
            </div>
          ))
        )}
      </div>

      <button
        onClick={handleNewPrescription}
        data-testid="add-prescription-btn"
        className="text-sm text-indigo-600 hover:text-indigo-800 underline font-medium"
      >
        {tIndex.addPrescription || '+ Add sequence'}
      </button>

      {selectedEvent && (
        <PrescriptionModal
          event={selectedEvent}
          isOpen={!!selectedEvent}
          onClose={() => setSelectedEvent(null)}
          onSave={onEventSave}
          onDelete={onEventDelete}
          langUrl={langUrl}
          demoMode={demoMode}
          trads={trads}
          calendarTimezone={calendar?.timezone || 'Europe/Paris'}
        />
      )}
    </div>
  );
}
